
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/document/[document_type]",
      function () {
        return require("private-next-pages/document/[document_type]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/document/[document_type]"])
      });
    }
  